import { FeatureConfiguration } from "features";
import { reducer } from "features/menu/reducers";
import * as actions from "features/menu/actions";
export * from "features/menu/types";
export { actions };

export default function (config: FeatureConfiguration) {
    config.reducers.menus = reducer;
}
